/*
  sk-signup-popup.js — the email sign-up pop-up (snippets/sk-signup-popup.liquid).

  When it shows: 8s into the first page or half way down it, whichever comes
  first; 3s into any later page of the visit; or, on desktop, when the pointer
  heads for the tab bar. Never while the cart drawer, menu or cookie banner is
  up, or while someone is typing in a field. "No thanks" hides it for 7 days
  and leaves a small "10% off" button; signing up hides it for good.

  Sign-up submits the theme's native customer form the normal way, so
  Shopify's bot check (hCaptcha) can run. Shopify answers a good post with
  ?customer_posted=true on the page it returns, where the pop-up reopens on
  the success step; an error reopens the email step with Shopify's message.
  WELCOME10 is applied by visiting /discount/WELCOME10 in the background.

  Country and language (what Selecty used to do): "We ship to <country>" shows
  only when Shopify's own geo lookup puts the visitor in the store's current
  country (snippets/geo-localization.liquid switches the store to a shippable
  country on the first visit). A "view in <language>" button shows when the
  browser prefers a language the store has and the page is in another one.
*/
(() => {
  const root = document.getElementById('SkSignup');
  if (!root || window.__skSignup) return;
  window.__skSignup = true;

  const KEY = 'sk-signup';
  const DAY = 24 * 60 * 60 * 1000;
  const teaser = document.getElementById('SkSignupTeaser');
  const form = document.getElementById('SkSignupForm');
  const email = document.getElementById('SkSignupEmail');
  const error = document.getElementById('SkSignupError');
  let config = {};
  try { config = JSON.parse(document.getElementById('SkSignupConfig').textContent); } catch (e) {}

  const store = {
    get(k, session) { try { return JSON.parse((session ? sessionStorage : localStorage).getItem(k)); } catch (e) { return null; } },
    set(k, v, session) { try { (session ? sessionStorage : localStorage).setItem(k, JSON.stringify(v)); } catch (e) {} },
    del(k, session) { try { (session ? sessionStorage : localStorage).removeItem(k); } catch (e) {} },
  };

  const LANGUAGE_PROMPTS = {
    en: 'View in English', de: 'Auf Deutsch ansehen', es: 'Ver en español', fr: 'Voir en français',
    nl: 'Bekijk in het Nederlands', ja: '日本語で見る', 'zh-CN': '查看中文版', zh: '查看中文版',
  };

  let choice = null;
  let opened = false;
  let lastFocus = null;

  const isSheet = () => matchMedia('(max-width: 749px)').matches;

  /* ---------- steps ---------- */
  function goto(step) {
    // Phones: steps have their own heights, so pin the card's top edge where
    // the first step put it. It then only grows or shrinks at the bottom, and
    // the email step stays high, clear of the on-screen keyboard.
    const panel = root.querySelector('.sk-signup__panel');
    if (root.classList.contains('is-open') && isSheet() && panel && !root.style.paddingTop) {
      root.style.paddingTop = Math.round(panel.getBoundingClientRect().top) + 'px';
      root.style.alignItems = 'flex-start';
    }
    root.querySelectorAll('[data-sk-step]').forEach((el) => { el.hidden = el.dataset.skStep !== String(step); });
    root.setAttribute('aria-labelledby', 'SkSignupTitle' + step);
    const focusable = root.querySelector('[data-sk-step="' + step + '"] ' + (step === 2 ? 'input[type=email]' : 'button, a'));
    if (focusable && opened) focusable.focus({ preventScroll: true });
  }

  function open(step) {
    if (opened) return;
    opened = true;
    lastFocus = document.activeElement;
    if (teaser) teaser.hidden = true;
    root.hidden = false;
    if (isSheet()) document.documentElement.classList.add('sk-signup-lock');
    goto(step || 1);
    requestAnimationFrame(() => requestAnimationFrame(() => root.classList.add('is-open')));
    document.addEventListener('keydown', onKey);
  }

  function close(dismiss) {
    if (!opened) return;
    opened = false;
    root.classList.remove('is-open');
    document.removeEventListener('keydown', onKey);
    document.documentElement.classList.remove('sk-signup-lock');
    setTimeout(() => { if (!opened) { root.hidden = true; root.style.paddingTop = root.style.alignItems = ''; } }, 320);
    const state = store.get(KEY);
    if (dismiss && !(state && state.s === 'subscribed')) {
      store.set(KEY, { s: 'dismissed', until: Date.now() + 7 * DAY });
      if (teaser) teaser.hidden = false;
    }
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  function onKey(e) {
    if (e.key === 'Escape') { close(true); return; }
    if (e.key !== 'Tab') return;
    const items = [...root.querySelectorAll('button, a[href], input')].filter((el) => !el.closest('[hidden]') && el.getClientRects().length);
    if (!items.length) return;
    const first = items[0], last = items[items.length - 1];
    if (!root.contains(document.activeElement)) { e.preventDefault(); (e.shiftKey ? last : first).focus(); return; }
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  /* ---------- choices ---------- */
  function choose(btn) {
    choice = btn.dataset.skChoice;
    const label = btn.querySelector('span').textContent.trim();
    root.querySelector('[data-sk-tags]').value = 'newsletter,popup,interest-' + choice;
    const shop = root.querySelector('[data-sk-shop]');
    const shopLabel = root.querySelector('[data-sk-shop-label]');
    if (config.collections && config.collections[choice]) shop.href = config.collections[choice];
    shopLabel.textContent = (shopLabel.dataset.template || '%CATEGORY%').replace('%CATEGORY%', label);
    store.set('sk-signup-choice', { choice, label }, true);
    goto(2);
  }

  /* ---------- sign-up ---------- */
  function showError(msg) {
    error.textContent = msg;
    error.hidden = !msg;
    email.setAttribute('aria-invalid', msg ? 'true' : 'false');
  }

  function succeed() {
    store.set(KEY, { s: 'subscribed', at: Date.now() });
    store.del('sk-signup-pending', true);
    fetch(config.discountUrl || '/discount/WELCOME10', { credentials: 'same-origin', redirect: 'follow' }).catch(() => {});
    if (teaser) teaser.hidden = true;
    goto(3);
  }

  // Runs in the capture phase, before Shopify's own form scripts (its bot
  // check, hCaptcha, hooks the submit too). A bad address stops here; a good
  // one is left to submit normally, so the bot check always gets its turn.
  // The page Shopify returns reopens the pop-up on the success step, or on
  // the email step with Shopify's error message.
  function submit(e) {
    const value = email.value.trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(value)) {
      e.preventDefault();
      e.stopImmediatePropagation();
      showError(error.dataset.invalid || 'Please enter a valid email address.');
      email.focus();
      return;
    }
    showError('');
    store.set('sk-signup-pending', { email: value, y: Math.round(scrollY) }, true);
    const button = root.querySelector('[data-sk-submit]');
    button.classList.add('is-loading');
    button.setAttribute('aria-busy', 'true');
    // Still here 12s later (the bot check never finished, e.g. blocked by an
    // ad blocker): give the button back so the visitor can try again.
    setTimeout(() => { button.classList.remove('is-loading'); button.removeAttribute('aria-busy'); }, 12000);
  }

  /* ---------- country and language ---------- */
  function localize() {
    // "We ship to <country>": the visitor's detected country, named in the page
    // language, whenever it is one the store ships to (hidden when it isn't).
    // If the lookup returns nothing, fall back to the store's current country
    // (geo-localization.liquid has already switched it to the visitor's
    // country when it can).
    // Step 1 names the country; step 2 shows the same flag with the
    // free-shipping threshold instead.
    const ships = root.querySelectorAll('[data-sk-ship]');
    const countries = config.countries || {};
    const showShip = (iso) => {
      const country = countries[iso];
      if (!country) return;
      ships.forEach((ship) => {
        const slot = ship.querySelector('[data-sk-ship-country]');
        if (slot) slot.textContent = (slot.dataset.template || '%COUNTRY%').replace('%COUNTRY%', country.name);
        const flag = ship.querySelector('[data-sk-ship-flag]');
        if (flag && country.flag) { flag.src = country.flag; flag.hidden = false; }
        ship.hidden = false;
      });
    };
    if (ships.length && config.suggestUrl) {
      fetch(config.suggestUrl, { headers: { Accept: 'application/json' } })
        .then((r) => r.json())
        .then((d) => {
          const detected = d && d.detected_values && d.detected_values.country && d.detected_values.country.handle;
          if (detected) showShip(detected); // hidden if we don't ship there
          else showShip(config.country);
        })
        .catch(() => showShip(config.country));
    }
    const lang = root.querySelector('[data-sk-lang]');
    const available = (config.languages || []).map((l) => l.iso);
    const current = config.language;
    const wanted = (navigator.languages || [navigator.language || ''])
      .map((l) => {
        const exact = available.find((a) => a.toLowerCase() === l.toLowerCase());
        return exact || available.find((a) => a.split('-')[0].toLowerCase() === l.split('-')[0].toLowerCase());
      })
      .find(Boolean);
    if (lang && wanted && wanted !== current && LANGUAGE_PROMPTS[wanted]) {
      lang.textContent = LANGUAGE_PROMPTS[wanted] + ' →';
      lang.lang = wanted;
      lang.hidden = false;
      lang.addEventListener('click', () => {
        const f = document.getElementById('SkSignupLanguageForm');
        if (!f) return;
        f.querySelector('[name="language_code"]').value = wanted;
        store.set('sk-signup-resume', 1, true);
        f.submit();
      });
    }
  }

  /* ---------- when to show ---------- */
  function blocked() {
    if (document.body.classList.contains('overflow-hidden')) return true;
    // The cookie banner is position: fixed, so offsetParent can't tell if it
    // is showing; its boxes and computed style can.
    const cookie = document.querySelector('#shopify-pc__banner, .shopify-pc__banner');
    if (cookie && cookie.getClientRects().length && getComputedStyle(cookie).visibility !== 'hidden' && getComputedStyle(cookie).opacity !== '0') return true;
    const a = document.activeElement;
    if (a && /^(INPUT|TEXTAREA|SELECT)$/.test(a.tagName) && !root.contains(a)) return true;
    if (document.querySelector('dialog[open], .quick-add-modal[open], modal-dialog[open]')) return true;
    return false;
  }

  function showWhenClear() {
    if (opened || (store.get(KEY) || {}).s === 'subscribed') return;
    if (blocked()) { setTimeout(showWhenClear, 1500); return; }
    open(1);
  }

  function schedule() {
    const views = (store.get('sk-signup-views', true) || 0) + 1;
    store.set('sk-signup-views', views, true);
    let fired = false;
    const fire = () => { if (fired) return; fired = true; cleanup(); showWhenClear(); };
    const onScroll = () => {
      const max = document.documentElement.scrollHeight - innerHeight;
      if (max > 0 && scrollY / max >= 0.5) fire();
    };
    const onLeave = (e) => { if (!e.relatedTarget && e.clientY <= 0 && performance.now() > 3000) fire(); };
    const cleanup = () => { removeEventListener('scroll', onScroll); document.removeEventListener('mouseout', onLeave); };
    setTimeout(fire, views > 1 ? 3000 : 8000);
    if (views === 1) addEventListener('scroll', onScroll, { passive: true });
    if (matchMedia('(hover: hover) and (pointer: fine)').matches) document.addEventListener('mouseout', onLeave);
  }

  /* ---------- wiring ---------- */
  root.addEventListener('click', (e) => {
    const t = e.target.closest('[data-sk-dismiss], [data-sk-choice], [data-sk-goto], [data-sk-copy], [data-sk-shop]');
    if (!t) return;
    if (t.hasAttribute('data-sk-dismiss')) close((store.get(KEY) || {}).s !== 'subscribed');
    else if (t.dataset.skChoice) choose(t);
    else if (t.dataset.skGoto) goto(Number(t.dataset.skGoto));
    else if (t.hasAttribute('data-sk-copy')) {
      const label = t.querySelector('span');
      const done = () => { label.textContent = t.dataset.copied || 'Copied'; };
      if (navigator.clipboard) navigator.clipboard.writeText('WELCOME10').then(done, done); else done();
    } else if (t.hasAttribute('data-sk-shop')) store.set(KEY, { s: 'subscribed', at: Date.now() });
  });
  form.addEventListener('submit', submit, true);
  if (teaser) teaser.addEventListener('click', () => open(1));

  localize();

  const state = store.get(KEY) || {};
  const pending = store.get('sk-signup-pending', true);
  if (pending) {
    const saved = store.get('sk-signup-choice', true);
    const btn = saved && root.querySelector('[data-sk-choice="' + saved.choice + '"]');
    if (btn) choose(btn);
    if (/customer_posted=true/.test(location.search)) {
      // Back where they were, with a clean address (the head script in
      // layout/theme.liquid already removed Shopify's #contact_form jump).
      try { history.replaceState(null, '', location.pathname); } catch (e) {}
      if (pending.y) scrollTo({ top: pending.y, behavior: 'instant' });
      open(3);
      succeed();
      return;
    }
    const failed = form.querySelector('[data-sk-form-error]');
    store.del('sk-signup-pending', true);
    if (failed) {
      open(2);
      email.value = pending.email || '';
      showError(failed.textContent.trim());
      return;
    }
  }
  if (state.s === 'subscribed') return;
  if (store.get('sk-signup-resume', true)) { store.del('sk-signup-resume', true); open(1); return; }
  if (state.s === 'dismissed' && state.until > Date.now()) { if (teaser) teaser.hidden = false; return; }
  schedule();
})();
